<div class="change-password-dialog">

  <!-- Close button -->
  <div class="dialog-title-row">
    <span></span>
    <button class="btn-close-dialog" mat-dialog-close><i class="fa-light fa-times"></i></button>
  </div>

  <!-- Header -->
  <div class="dialog-header">
    <div class="dialog-icon-wrap">
      <i class="fa-light fa-lock"></i>
    </div>
    <h2 class="dialog-title">Cambiar contraseña</h2>
    <p class="dialog-subtitle">Introduce tu contraseña actual y elige una nueva segura.</p>
  </div>

  <form [formGroup]="changeForm" (ngSubmit)="changePassword()">

    <!-- Contraseña actual -->
    <div class="field-group">
      <label class="field-label">Contraseña actual</label>
      <div class="input-wrap">
        <i class="fa-light fa-lock-keyhole input-icon"></i>
        <input [type]="hideActual ? 'password' : 'text'" placeholder="Introduce tu contraseña actual"
          formControlName="password" required />
        <i class="fa-regular {{ hideActual ? 'fa-eye' : 'fa-eye-slash' }} toggle-eye"
          (click)="hideActual = !hideActual"></i>
      </div>
    </div>

    <!-- Nueva contraseña -->
    <div class="field-group">
      <label class="field-label">Nueva contraseña</label>
      <div class="input-wrap" [class.input-invalid]="pass.invalid && (pass.dirty || pass.touched)">
        <i class="fa-light fa-key input-icon"></i>
        <input [type]="hide ? 'password' : 'text'" placeholder="Mínimo 8 caracteres"
          formControlName="textPassword" required />
        <i class="fa-regular {{ hide ? 'fa-eye' : 'fa-eye-slash' }} toggle-eye" (click)="hide = !hide"></i>
      </div>

      <!-- Validaciones -->
      <div class="password-rules" *ngIf="pass.dirty || pass.touched">
        <div class="rule" [class.rule-ok]="!pass.errors?.['hasSmallCase']">
          <i class="fa-light {{ pass.errors?.['hasSmallCase'] ? 'fa-circle' : 'fa-circle-check' }}"></i>
          <span>Minúsculas</span>
        </div>
        <div class="rule" [class.rule-ok]="!pass.errors?.['hasCapitalCase']">
          <i class="fa-light {{ pass.errors?.['hasCapitalCase'] ? 'fa-circle' : 'fa-circle-check' }}"></i>
          <span>Mayúsculas</span>
        </div>
        <div class="rule" [class.rule-ok]="!pass.errors?.['hasNumber']">
          <i class="fa-light {{ pass.errors?.['hasNumber'] ? 'fa-circle' : 'fa-circle-check' }}"></i>
          <span>Números</span>
        </div>
        <div class="rule" [class.rule-ok]="!pass.errors?.['minlength'] && !pass.errors?.['required']">
          <i class="fa-light {{ (pass.errors?.['minlength'] || pass.errors?.['required']) ? 'fa-circle' : 'fa-circle-check' }}"></i>
          <span>8 caracteres mínimo</span>
        </div>
      </div>
    </div>

    <!-- Confirmar contraseña -->
    <div class="field-group">
      <label class="field-label">Confirmar nueva contraseña</label>
      <div class="input-wrap" [class.input-invalid]="(repPass.dirty || repPass.touched) && changeForm.errors?.['passwordNotMatch']">
        <i class="fa-light fa-key input-icon"></i>
        <input [type]="hideConfirm ? 'password' : 'text'" placeholder="Repite la nueva contraseña"
          formControlName="confirmPassword" required />
        <i class="fa-regular {{ hideConfirm ? 'fa-eye' : 'fa-eye-slash' }} toggle-eye"
          (click)="hideConfirm = !hideConfirm"></i>
      </div>
      <p class="error-msg" *ngIf="(repPass.dirty || repPass.touched) && changeForm.errors?.['passwordNotMatch']">
        <i class="fa-light fa-triangle-exclamation"></i> Las contraseñas no coinciden.
      </p>
    </div>

    <!-- Botón -->
    <button type="submit" class="submit-btn" [disabled]="changeForm.invalid">
      Actualizar contraseña
    </button>

  </form>
</div>
